// src/context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();
const REACT_APP_TEST ='https://api.nownfc.com:5007';


export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check local storage on initial load
        const adminData = localStorage.getItem('adminInfo');
        if (adminData) {
            setAdmin(JSON.parse(adminData));
        }
        setLoading(false);
    }, []);

    const login = async (username, password) => {
        try {
            const config = { headers: { 'Content-Type': 'application/json' } };
            const { data } = await axios.post(
                `${REACT_APP_TEST}/api/admin/login`, // Your API URL
                 
                { username, password },
                config
            );
            localStorage.setItem('adminInfo', JSON.stringify(data));
            setAdmin(data);
            return { success: true };
        } catch (error) {
            const message = error.response && error.response.data.message
                ? error.response.data.message
                : 'An unexpected error occurred';
            return { success: false, error: message };
        }
    };

    const logout = () => {
        localStorage.removeItem('adminInfo');
        setAdmin(null);
    };

    const value = {
        admin,
        login,
        logout,
        isAdmin: !!admin, // A handy boolean
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};